<template>
  <v-progress-circular
    v-if="apiCall.loading"
    :size="120"
    data-tst="table_loader"
    class="ma-auto"
    :model-value="80"
    :indeterminate="true"
  ></v-progress-circular>
  <div
    v-else-if="apiCall.error"
    class="f-column f-center mt-16 mx-auto px-8"
    style="max-width: 420px"
  >
    <div class="user-message error-message text-center">
      <i
        style="font-size: 6rem"
        class="text-ultra clr-error mdi mdi-alert-circle-outline"
      ></i>
      <div
        class="user-message_title text-semi-large"
        v-html="$t('messages.error_loading_coachings')"
      ></div>
    </div>
  </div>
  <div
    v-else
    id="coaching"
    class="coaching"
  >
    <div class="coaching_inner">
      <div class="coaching_title">
        <h1 class="text-mega weight_700">{{ $t('coachings.title') }}</h1>
        <div class="text-semi-large weight_500 clr-grey">
          {{ $t('coachings.subtitle') }}
        </div>
      </div>

      <SimpleTabs
        :options="tabs"
        :value="activeTab"
        class="tabs-stretch coaching_tabs"
        style="--height: 4rem"
        @input="setTab"
      >
        <template #default="v">
          <div>
            {{ $t(`coachings.${v.item}_short`) }}
          </div>
        </template>
      </SimpleTabs>

      <div class="coaching_tab_content">
        <CalendarLinks
          v-show="activeTab === 'upcoming_coachings'"
          class="anim-fade-in mx-auto"
        />
        <FutureCoachings
          v-if="activeTab === 'upcoming_coachings'"
          :items="videos"
          class="anim-fade-in"
        />
        <VideoList
          v-if="activeTab === 'previous_coachings'"
          :items="videos"
          class="anim-fade-in"
          @toggle:favorite="item => handleItemToggle('is_favorite', item)"
          @toggle:watched="item => handleItemToggle('is_watched', item)"
        />
      </div>

      <div class="mt-16"></div>
      <section class="our-coaches mt-8 pb-16 pt-4">
        <div class="text-mega weight_700 mt-16 mb-4 f-center">
          {{ $t('coachings.our_coaches') }}
        </div>
        <CoachesSlideshow
          class="coaching_slideshow pb-16"
          style="--sld-height: 32rem"
        />
      </section>
    </div>

    <div
      v-if="nadaPurchased"
      class="green-banner"
    >
      <div class="z-index_1 text-big px-4 weight_500 text-center">
        {{ $t('messages.start_crushing_with_us') }}
      </div>
      <v-btn
        style="border: solid 2px currentColor"
        color="white"
        size="x-large"
        variant="outlined"
        class="z-index_1 mt-8"
        @click="$router.push({ name: 'Subscription' })"
      >
        <i class="mdi mdi-crown mr-2 text-semi-large"></i>
        {{ $t('btn.upgrade') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import SimpleTabs from '@/components/AppBar/SimpleTabs'
import VideoList from '@/components/lib/VideoList'
import tier_mix from '@/mixins/tier_mix'
import format_mix from '@/mixins/format_mix'
import FutureCoachings from '@/components/lib/FutureCoachings'
import CalendarLinks from '@/components/lib/CalendarLinks'
import CoachesSlideshow from '@/components/lib/CoachesSlideshow'
import { getMappedCoachingItem } from '@/helpers/coachings'

export default {
  name: 'Coaching',
  components: {
    VideoList,
    FutureCoachings,
    CoachesSlideshow,
    CalendarLinks,
    SimpleTabs,
  },
  mixins: [tier_mix, format_mix],
  data() {
    return {
      tabs: ['previous_coachings', 'upcoming_coachings'],
    }
  },
  created() {
    this.$store.dispatch('api_coachings')
    if (!this.activeTab) {
      this.setTab('upcoming_coachings')
    }
  },
  methods: {
    setTab(tab) {
      this.$router
        .push({
          query: {
            ...this.$route.query,
            tab,
          },
        })
        .catch(() => {})
    },
    async handleItemToggle(key, item, bool) {
      if (key === 'is_watched' && !item.video_id && !item.preview_video_id) return
      if ((bool ?? !item[key]) === item[key]) return
      // is_watched
      // is_favorite
      // console.log(bool)
      const uItem = {
        [key]: bool ?? !item[key],
      }
      const currentVideoList = JSON.parse(JSON.stringify(this.videoList))

      const newVideoList = currentVideoList.map(i => {
        if (i.id === item.id) {
          return {
            ...i,
            ...uItem,
          }
        }
        return i
      })
      this.$store.commit('api_update_data', { key: 'api_coachings', data: newVideoList })

      const res = await this.$store.dispatch('api_call', {
        method: 'PATCH',
        endpoint: `poker/coaching/lessons/${item.id}/`,
        // apiVersion: this.tcrud_conf.apiVersion || '',
        data: uItem,
        hasCancel: false,
        message: {
          type: 'error',
        },
      })
      if ((!res?.response || res?.response?.error) && currentVideoList) {
        this.$store.commit('api_update_data', { key: 'api_coachings', data: currentVideoList })
      }
    },
  },
  computed: {
    apiCall() {
      return this.$store.getters.api_get('api_coachings')
    },
    videoList() {
      return (this.$store.getters.api_get_data('api_coachings') || []).filter(i => i?.coach)
    },
    videos() {
      const res = this.videoList.map((item, idx) => {
        const r = getMappedCoachingItem({
          item,
          locale: this.$i18n.locale,
        })
        return r
      })
      return res
    },
    activeTab() {
      return this.$route.query.tab || 'previous_coachings'
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
  },
}
</script>
<style lang="scss" scoped>
.coaching {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: var(--vh-3);
  width: 100vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;

  &_inner {
    position: relative;
    flex: 1;
    display: flex;
    align-content: flex-start;
    flex-direction: column;

    width: 1366px;
    padding: 0 2rem;
    max-width: 100vw;
  }
  &_title {
    margin-top: 4rem;
    text-align: center;
  }
  &_slideshow {
    max-width: 100%;
    padding: 2rem 0 0 0;
  }
  &_tabs {
    margin: 3rem auto 0 auto;
    max-width: 960px;
    width: 100%;
  }
  &_tab {
    &_content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: 4rem;
    }
  }
}

.green-banner {
  margin-top: 10rem;
  min-height: 20rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  &:before {
    z-index: 1;
    content: '';
    height: 100%;
    width: 100vw;
    position: absolute;
    background: var(--clr-primary);
    background-image: linear-gradient(rgba(160, 93, 0, 0), #00c9a4);
    background-size: 211% 211%;
  }
}

@media (min-width: 3440px) {
  .coaching {
    &_inner {
      width: 2560px;
    }
    &_slideshow {
      max-width: 1980px;
    }
    &_tabs {
      max-width: 1980px;
    }
  }
}

@media (max-width: 1023px) {
  .coaching {
    &_slideshow {
      max-width: calc(100vw - 1rem);
    }
    &_inner {
      padding: 0 0.5rem;
    }
  }
}
</style>
